import bike_white from "../../Assets/svg/bike_white.svg"
import car_white from "../../Assets/svg/car_white.svg"
import truck_white from "../../Assets/svg/truck_white.svg"
import walk_white from "../../Assets/svg/walk_white.svg"

const profiles = {
  car: {
    icon: car_white,
    name: "Car",
    mapbox: "mapbox/driving-traffic",
  },
  foot: {
    icon: walk_white,
    name: "Walk",
    mapbox: "mapbox/walking",
  },
  truck: {
    icon: truck_white,
    name: "Truck",
  },
  motorcycle: {
    icon: bike_white,
    name: "Bike",
  },
}

export const get_transportation_profiles = (key) => {
  if (!key) return profiles;
  const profile = profiles?.[key];
  if (profile) return profile;
  return null;
};

